import classNames from 'classnames';
import PropTypes from 'prop-types';
import './radio-btn.scss';

export const RadioBtn = (props) => {
    const {
        icon,
        input,
        type,
        label,
        onClick,
        meta: { error },
        className,
        children,
    } = props;
    const errorId = input?.name ? `error-radio-${input.name}` : undefined;

    return (
        <>
            <label
                className={classNames(`${className}`, {
                    'border-danger': input.checked && error,
                    active: input.checked,
                })}
            >
                <input
                    type={type}
                    {...input}
                    className="visually-hidden"
                    aria-invalid={error ? 'true' : undefined}
                    aria-describedby={input.checked && error ? errorId : undefined}
                    onClick={onClick}
                    onKeyDown={(e) => {
                        // RGAA 7.4 : empêche la validation/passage automatique à l'étape suivante via Enter sur un radio
                        if (e.key === 'Enter') {
                            e.preventDefault();
                        }
                    }}
                />
                {icon && (
                    <div className={'icon mb-4'}>
                        <img src={icon} alt="" aria-hidden="true" />
                    </div>
                )}
                <span className={'d-block'} dangerouslySetInnerHTML={{__html: label}} />
                {children ? children : ''}
            </label>
            {input.checked && error && (
                <small id={errorId} className="alert alert-danger invalid-feedback d-block" role="alert">{error}</small>
            )}
        </>
    );
};
